import moment from "moment/moment"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from "react-bootstrap/Tooltip"
import reel from "../../../assets/images/services-icon/reel.png"
import awicon from "../../../assets/images/services-icon/coin.png"
import React from "react"
import { Session } from "../session"
import { ActivityUtil } from "./activity-util"
import { ActivityCardContextMenu, ActivityCardContextMenuProps } from "./activity-card-context-menu"
import { ActivityCardCommonProps } from "./activity-card"
import { LessonActivityEnglishAQ } from "./lesson-activity.types"

interface EnglishOnlineActivityCardProps {
  activity: LessonActivityEnglishAQ
  sessionData: Session
  studentKey?: string
  index: number
  checkable: boolean
}

type CardProps = EnglishOnlineActivityCardProps & ActivityCardCommonProps

export const EnglishOnlineActivityCard = (props: CardProps) => {

  const { activity, sessionData, studentKey: activityStudentKey, index } = props
  const { checkbox } = props
  // const { checked, onCheckedChanged, checkable } = props
  const {manualMarkActivity, ...props2} = props

  let total_coins = 0
  let total_time = 0

  let total_question = 0
  let count_answer = 0
  let manual_mark = 0
  let manual_mark_review = 0
  if (
    activity.LessonActivitiesQuestions?.length > 0
  ) {

    activity.LessonActivitiesQuestions.forEach(
      (activityQuestion) => {
        manual_mark_review += activityQuestion.marked_for_manual_marking

        activityQuestion.english_question?.forEach(
          (question) => {

            question.english_question_parts.forEach(
              (questionpart) => {
                if (question.english_question_category_id === 10 ||
                  question.english_question_category_id === 13
                ) {
                  questionpart.english_question_answers?.length > 0 &&
                  questionpart.english_question_answers?.[0]?.english_answer_text != ""
                    ? ((total_question += 1),
                      (total_coins += 2), (questionpart.english_question_part_automark === 0 ? manual_mark += 1 : null))
                    : null
                } else {
                  total_question += 1
                  total_coins += 2
                  questionpart.english_question_part_automark === 0 ? manual_mark += 1 : null
                }
                if (questionpart.StudentAnsAttempts?.length > 0) {
                  questionpart.StudentAnsAttempts.forEach(
                    stuAnswer => {
                      total_time += stuAnswer.submitted_on
                    }
                  )
                  count_answer += 1 // Increment count_answer by 1 for each occurrence
                }
              }
            )
          }
        )
      }
    )
  }

  const manualMarkActivity2: ActivityCardContextMenuProps['manualMarkActivity'] = manualMarkActivity ? {
    enabled: !!(
      manual_mark &&
      manual_mark > 0 &&
      manual_mark_review === 0 &&
      activity.status === 1 &&
      manualMarkActivity?.enabled),
      onActivate: manualMarkActivity.onActivate
  } : undefined;


  return (
    <div className={`${(() => {
      if (sessionData?.session?.ses_is_completed === 1) {
        if (activity.status === 1 && activity.mastryScore) {
          const score = activity.mastryScore
          if (score > 75) return "activity-card-success"
          if (score < 75) return "activity-card-blue"
        } else if (activity.status === 1) {
          return "activity-card-blue"
        }
        return "activity-card-danger"
      }
      return ""
    })()} m-1 set1 bg-supermild`}>
      <div className="d-flex justify-content-between">
        <div>
          <span className="cs-txt-danger font-size-10 me-2">
                  {activity?.roll_date ? "Rolled over from" + moment(activity.roll_date, moment.ISO_8601).format("DD/MMM/YYYY")
                      : null}
          </span>
          <span
            className={`${
              activity.status === 0
                ? "cs-txt-danger"
                : activity.status === 1
                  ? "text-success"
                  : ""
            } font-size-10 me-2`}
          >
            {activity.status === 0
              ? "Incomplete"
              : activity.status === 1
                ? "Completed"
                : null}
          </span>
          <span className={`${
            activity.status === 0
              ? "cs-txt-danger"
              : activity.status === 1
                ? "text-success"
                : ""
          } font-size-10 me-2`}>
            {count_answer != null &&
            total_question != null
              ? count_answer +
              "/" +
              total_question +
              " attempted"
              : null}
          </span>
          <span className="cs-txt-danger font-size-10 me-2">
            {sessionData?.session?.ses_is_completed === 1 ? activity.mastryScore
                ? `Score: ${activity.mastryScore}` : `Score: 0`
              : null}
          </span>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className="custom-tooltip">
                  Comment:{" "}
                  {activity?.tutor_comments || "No comments available"}
                </Tooltip>
              }
            >
              <span className="no-bdr" style={{ cursor: "pointer" }}>
                <i className="fas fa-info-circle"></i>
              </span>
            </OverlayTrigger>
        </div>
        <div>
          {checkbox?.checkable &&
            <div>
              {(!activityStudentKey || activity.fk_student_key === activityStudentKey) &&
                <>
                  <input
                    type="checkbox"
                    checked={checkbox.checked}
                    onChange={checkbox.onCheckedChanged}
                  />
                </>}
            </div>
          }
        </div>
      </div>
      <h6 className="text-dark border-bottom pb-1 mb-0 mt-2 font-size-12 lh-sm fw-800">
        {(index + 1) + ") "} {ActivityUtil.activityName(activity)}
      </h6>

      <div className="d-flex justify-content-between mb-2 align-items-center mt-2 flex-wrap">
        <div className="d-flex align-items-center font-size-12 text-dark fw-400">
          <span>
            {" "}
            <img className="me-10" width={24} src={reel} alt="" />
          </span>
          {activity.activity_type === 8 ? "Summative" : "Online Activities"}
        </div>

        <ActivityCardContextMenu
          {...props2}
          manualMarkActivity={manualMarkActivity2}
        />

      </div>

      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center font-size-12 text-dark fw-400">
        </div>

        <div className="d-flex align-items-center font-size-12 text-dark fw-400">
          {" "}
          <img className="me-10" width={24} src={awicon} alt="" />
          {activity.coins_earned ? activity.coins_earned : 0}/{total_coins}{" "}
        </div>
      </div>

      <div className="question-count mt-2">
        <ul className="list-unstyled mb-0 d-flex align-items-center mt-1">
          {activity.LessonActivitiesQuestions?.length > 0
            ? activity.LessonActivitiesQuestions.map(
              (activityQuestion, index2) => {
                let color = 0
                let attempt = 0
                let manual_mark = 0
                let overRide = 0
                activityQuestion.english_question?.forEach(
                  (question) => {

                    if (question.english_question_parts.length > 0) {

                      question.english_question_parts.forEach(
                        (questionpart) => {
                          color = 0
                          attempt = 0
                          overRide = questionpart?.markedReport
                          if (questionpart.StudentAnsAttempts.length > 0) {
                            questionpart.StudentAnsAttempts.forEach((answerattquestion) => {
                                attempt += 1
                                color += answerattquestion.points_obtained
                              }
                            )
                          }
                          if ([10, 13].includes(question.english_question_category_id)) {
                            questionpart.english_question_answers.length > 0 &&
                            questionpart.english_question_answers?.[0]?.english_answer_text != ""
                              ? ((questionpart.english_question_part_automark === 0 ? manual_mark += 1 : null))
                              : null
                          } else {
                            questionpart.english_question_part_automark === 0 ? manual_mark += 1 : null
                          }
                        }
                      )
                    }
                  }
                )

                const colorInt = color
                const attemptInt = attempt
                const overRideInt = overRide
                return (
                  <li
                    key={index2}
                    className={`${
                      manual_mark > 0
                        ? ""
                        : attemptInt >= 2 &&
                        colorInt === 1
                          ? "attempt2 text-warning bg-success-subtle"
                          : attemptInt >= 1 &&
                          colorInt >= 2
                            ? "attempt1 custom-success bg-success-subtle"
                            : ((!overRideInt && attemptInt >= 2) || (overRideInt >= 1 && attemptInt >= 1)) &&
                            colorInt === 0
                              ? "attempt3 cs-txt-danger bg-danger-subtle"
                              : ""
                    }`}
                  >
                    {manual_mark > 0 ? (
                      "M"
                    ) : attemptInt >= 2 &&
                    colorInt === 1 ? (
                      <i className="fas fa-check"></i>
                    ) : attemptInt >= 1 &&
                    colorInt >= 2 ? (
                      <i className="fas fa-check"></i>
                    ) : ((!overRideInt && attemptInt >= 2) || (overRideInt >= 1 && attemptInt >= 1)) &&
                    colorInt === 0 ? (
                      <i className="mdi mdi-window-close"></i>
                    ) : (
                      index2 + 1
                    )}
                  </li>
                )
              }
            )
            : null}
        </ul>
      </div>
      {
        manual_mark > 0 &&
        manual_mark_review === 0 &&
        <div className="manual_mark_div">
          <span className="d-flex align-items-center gap-1">
            <i className="font-size-18 mdi mdi-alert-outline"></i>
            <p className="font-size-12 mb-0">
              Manual marking required
            </p>
          </span>
        </div>
      }
    </div>
  )

}



